export default __webpack_public_path__ + "static/media/logo-removebg-preview.2edb333f.png";